import { cs } from '@/utils/className';

import styles from './index.module.less';

export interface RepoSelectorCardProps {
  name: string;
  /** 除地址外的元信息，合并为一行并用 · 分隔 */
  metaItems?: (string | undefined | null)[];
  /** 地址单独一行展示 */
  address?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

/** 仓库/广场选择器卡片：标题 + 元信息行 + 地址行 */
export function RepoSelectorCard({ name, metaItems = [], address, selected, disabled, onClick }: RepoSelectorCardProps) {
  const metaLine = metaItems
    .map((item) => String(item ?? '').trim())
    .filter(Boolean)
    .join(' · ');
  const addressText = String(address ?? '').trim();

  return (
    <div
      className={cs(styles.repoCard, selected && styles.selected)}
      onClick={() => {
        if (disabled) return;
        onClick?.();
      }}
      role="button"
      tabIndex={disabled ? -1 : 0}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      }}
    >
      <div className={styles.cardName} title={name}>
        {name}
      </div>
      {metaLine ? (
        <div className={styles.cardMetaRow} title={metaLine}>
          {metaLine}
        </div>
      ) : null}
      {addressText ? (
        <div className={styles.cardAddress} title={addressText}>
          {addressText}
        </div>
      ) : null}
    </div>
  );
}
